// src/components/ProtectedRoute.jsx - ROUTE KORUMA (FIRESTORE ENTEGRE)
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

// Admin email listesi (fallback)
const ADMIN_EMAILS = [
  'info@tronapazarlama.com'
];

export function ProtectedRoute({ children, adminOnly = false }) {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        // Firestore'dan kullanıcı rolünü al
        try {
          const userDocRef = doc(db, 'Users', currentUser.uid);
          const userDocSnap = await getDoc(userDocRef);

          if (userDocSnap.exists()) {
            setUserRole(userDocSnap.data().role);
          } else {
            // Firestore'da yoksa email ile kontrol et (fallback)
            const isAdmin = ADMIN_EMAILS.includes(currentUser.email);
            setUserRole(isAdmin ? 'admin' : 'user');
          }
        } catch (error) {
          console.error('Role fetch error:', error);
          // Hata durumunda email ile kontrol et
          const isAdmin = ADMIN_EMAILS.includes(currentUser.email);
          setUserRole(isAdmin ? 'admin' : 'user');
        }
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: '#f8f9fa'
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '4px solid #e9ecef',
          borderTopColor: '#E5332A',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!user) {
    // Kullanıcı giriş yapmamış
    return <Navigate to="/account" state={{ from: location }} replace />;
  }

  if (adminOnly && userRole !== 'admin') {
    // Admin yetkisi yok
    return <Navigate to="/" replace />;
  }

  return children;
}

// Kullanıcı bilgisini almak için hook
export function useAuth() {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        // Firestore'dan kullanıcı rolünü al
        try {
          const userDocRef = doc(db, 'Users', currentUser.uid);
          const userDocSnap = await getDoc(userDocRef);

          if (userDocSnap.exists()) {
            setUserRole(userDocSnap.data().role);
          } else {
            // Firestore'da yoksa email ile kontrol et (fallback)
            const isAdmin = ADMIN_EMAILS.includes(currentUser.email);
            setUserRole(isAdmin ? 'admin' : 'user');
          }
        } catch (error) {
          console.error('Role fetch error:', error);
          const isAdmin = ADMIN_EMAILS.includes(currentUser.email);
          setUserRole(isAdmin ? 'admin' : 'user');
        }
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const isAdmin = userRole === 'admin';

  return { user, loading, isAdmin, userRole };
}